const checkIfIsInTheSameLine = ({
  modelsPerRow,
  selectedModelIndex,
  modelIndex,
  isLastElement,
}) => {
  if (isLastElement) {
    const selectedModelLine = Math.ceil((selectedModelIndex + 1) / modelsPerRow)
    const currentModelLine = Math.ceil((modelIndex + 1) / modelsPerRow)

    return selectedModelLine === currentModelLine
  }
  const relativeDistance = modelIndex - selectedModelIndex

  return relativeDistance >= 0 && relativeDistance <= modelsPerRow - 1
}

export default checkIfIsInTheSameLine
